module.exports = __webpack_public_path__ + "img/1tlaxcala_06.8feadcff.png";